class TransactionsOps {
  constructor() {
    this.ops = {
      "credit:create": "Mass Upload Credit / Topups",
      "credit:transfer": "Extra chash paid by customer",
      "dept:transfer": "Cash collected by captain from customer",
      "dept:fulfill": "Debt paid by captain to SWVL",

      charge: "Customer pays by cash, credit or card",
      refund: "Money refunded to user",
    };
  }
}

export default TransactionsOps;



// WEBPACK FOOTER //
// ./src/services/transactionsOps/transactionsOps.service.js